jQuery(document).ready( function($){

    /* Adds add threshold row button*/
    $('ul.nav-tabs a').on('click', function(){
        var container = $('div.col-md-6.col-sm-6.col-xs-12.col-md-offset-3');
        if( $(this).attr('aria-controls') == 'thresholds') {
            container.append('<a href="#" class="btn btn-default" id="addThreshold">Add Threshold Row</a>');
        } else {
            $('a#addThreshold').remove();
        }
    });

    /* adds threshold row on button click */
    $('body').on('click', 'a#addThreshold', function() {
        $('div.tab-pane#thresholds').append('<div class="row"><div class="col-xs-6"><label>Discount Threshold</label><input class="form-control " name="multibuy_threshold_count[]" type="text" value="0"></div><div class="col-xs-6"><label>Discount Amount</label><input class="form-control " name="multibuy_threshold_discount[]" type="text" value="0"></div></div>');
    });
});
